<template>
  <div style="height: 100%">
    <fdc-panel
      :title="'특정 레코드 상/하 이동'"
      style="height: 100%;"
    >
      <brique-grid
        style="width: 100%; height: 70%;"
        id="dataDragDrop"
        :brique-grid-columns="columnDefs"
        @grid-ready="onGridReady"
        :animate-rows="true"
        :default-col-def="defaultColDef"
        :row-selection="rowSelection"
        :row-data="rowData"

        :pagination="false"
        :row-drag-managed="true"
        :row-drag-multi-row="true"
        :suppress-move-when-row-dragging="true"
      />
      <hr>
      <monaco-editor
        ref="MonacoEditor"
        :code="comment"
        :automatic-layout="true"
        :read-only="true"
        :theme="'vs-dark'"
        style="height: 25%"
      />
    </fdc-panel>
  </div>
</template>

<script>
import MonacoEditor from '@/views/Fdc/EqpInfo/Components/MonacoEditor.vue'

export default {
  name: 'DataDragDrop',
  components: {
    'monaco-editor': MonacoEditor
  },
  methods: {
    async onGridReady (params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi

      await this.refreshData()
    },
    async refreshData () {
      const updateData = (data) => {
        this.rowData = data
        this.gridApi.setRowData(data)
      }

      await fetch('https://www.ag-grid.com/example-assets/olympic-winners.json')
        .then((resp) => resp.json())
        .then((data) => updateData(data.slice(0, 100).map(d => {
          d.date = d.date.split('/').reverse().join('/') // date format이 DD/MM/YYYY 여서 converting함
          return d
        })))
    }
  },
  data: function () {
    return {
      gridApi: null,
      columnApi: null,
      columnDefs: [
        { field: 'athlete', minWidth: 150, checkboxSelection: true, rowDrag: true },
        { field: 'age', maxWidth: 90, type: 'numericColumn' },
        { field: 'country', minWidth: 150 },
        { field: 'year', maxWidth: 90 },
        { field: 'date', minWidth: 150, type: 'dateColumn' },
        { field: 'sport', minWidth: 150 },
        { field: 'gold', type: 'numericColumn' },
        { field: 'silver', type: 'numericColumn' },
        { field: 'bronze', type: 'numericColumn' },
        { field: 'total', type: 'numericColumn' }
      ],
      defaultColDef: {
        // flex: 1,
        minWidth: 100,
        filter: true,
        resizable: true,
        sortable: true
      },
      rowSelection: 'multiple',
      rowData: null,
      comment: [
        '/*',
        ' * 주요 설정 (상세 사용법은 소스 참조)',
        ' * - BRIQUE Grid Component props 설정',
        ' * - BRIQUE Grid column 정의에 column row drag 활성화',
        ' */',
        '// Component props 설정',
        '` :pagination="false" ` // pagination을 비활성화 해야 drag&drop을 사용할 수 있다.',
        '` :row-drag-managed="true" `',
        '` :row-drag-multi-row="true" `',
        '` :suppress-move-when-row-dragging="true" `',
        '// column data type 지정',
        'columnDefs: [',
        '\t{ field: \'athlete\', minWidth: 150, checkboxSelection: true, rowDrag: true }, // rowDrag: true 추가',
        ']'
      ].join('\n')
    }
  }
}
</script>

<style lang="scss">
  .fdc-panel {
    .panel-body {
      padding: 10px;
    }
  }
</style>
